import React from "react";
import { Label, Tooltip } from "@patternfly/react-core";

export const SheetTypesCell = ({ row, Icons, groupFilter }) => {

  // Pobieramy dane tylko dla wybranej grupy
  const groupData = groupFilter
    ? Object.values(row?.groups_completed || {})
        .find(g => g.group_symbol === groupFilter)
    : null;

  const completedTypes = groupData?.completed_sheet_type || [];
  const repetitions = groupData?.repetitions || 0;
  const totalExercises = groupData?.number_of_exercises || 0;

  return (
    (row.types || []).map((type) => {

      let color; // undefined = domyślny PatternFly
      let colorOutline;

      if (groupFilter && groupData) {
        const isCompleted = completedTypes.includes(type.sheet_type);

        if (repetitions > 1) {
          color = "gold";
        } else if (isCompleted && completedTypes.length <= totalExercises) {
            colorOutline = "green"
            color = "#afdc8f";
        } else if (isCompleted) {
          color = "blue";
        }
      }

      const IconComponent = Icons[type.icon_name];

      return (
        <span key={type.uid}>
          {IconComponent
            ? (
              <Tooltip content={<div>{type.sheet_type.toUpperCase()} - {type.short_description}</div>}>
                {React.cloneElement(IconComponent, { 
                  color, 
                  style: { verticalAlign: 'middle',  marginRight: "5px" } 
                })}
              </Tooltip>
            )
            : (
              <Tooltip content={<div>{type.sheet_type.toUpperCase()} - {type.short_description}</div>}>
                <Label
                  isCompact
                  variant="outline"
                  color={colorOutline} // jeśli color undefined → PatternFly użyje domyślnego
                  style={{
                    fontSize: "10px",
                    padding: "1px 4px",
                    whiteSpace: "nowrap",
                    marginRight: "2px"
                  }}
                >
                  {type.sheet_type.toUpperCase()}
                </Label>
              </Tooltip>
            )
          }
        </span>
      );
    })
  );
};